
import React from 'react';
import JournalistOnboarding from '@/components/onboarding/journalist/JournalistOnboarding';

const JournalistOnboardingPage: React.FC = () => {
  return <JournalistOnboarding />;
};

export default JournalistOnboardingPage;
